module.exports = __webpack_public_path__ + "img/kachel-ALLERGIEN_SONNENPFLEGE.c51b80d2.png";